export class TestStore {
  constructor(private testS: string) {
    console.log("test store 89 !!" + testS)
  }

  test() {
    return "----" + this.testS + "--------"
  }
}

;((window as any).up = (window as any).up || {}).TestStore = TestStore
